var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaireFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.321,
    height: 31.585,
    viewBox: "0 0 26.321 31.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-upload",
    d: "M25.815,7.092,21.229,2.506A8.5,8.5,0,0,0,15.18,0H7.922A5.929,5.929,0,0,0,2,5.922V25.663a5.929,5.929,0,0,0,5.922,5.922H22.4a5.929,5.929,0,0,0,5.922-5.922V13.141a8.5,8.5,0,0,0-2.506-6.049Zm-.93.93a7.221,7.221,0,0,1,1.636,2.506H19.767a1.976,1.976,0,0,1-1.974-1.974V1.8A7.221,7.221,0,0,1,20.3,3.436ZM27,25.663A4.611,4.611,0,0,1,22.4,30.269H7.922a4.611,4.611,0,0,1-4.606-4.606V5.922A4.611,4.611,0,0,1,7.922,1.316H15.18a7.306,7.306,0,0,1,1.3.116V8.554a3.3,3.3,0,0,0,3.29,3.29h7.122a7.306,7.306,0,0,1,.116,1.3V25.663ZM20.31,18.622a.658.658,0,0,1-.941.921l-3.31-3.382a1.208,1.208,0,0,0-.241-.187v9.69a.658.658,0,1,1-1.316,0V15.975a1.3,1.3,0,0,0-.246.192l-3.3,3.377a.658.658,0,0,1-.941-.92l3.31-3.382a2.6,2.6,0,0,1,1.827-.763h.024a2.579,2.579,0,0,1,1.821.758l3.315,3.387Z",
    transform: "translate(-2)",
    fill: "#387f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireFileUpload);
export default __webpack_public_path__ + "static/media/questionnaire-file-upload.9a54094c619cd635a43b64f783bd5f88.svg";
export { ForwardRef as ReactComponent };